import { DatePipe } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AlertsCenterService } from 'src/app/core/services/alerts-center.service';
import { EntiService } from 'src/app/services/enti.service';

@Component({
  selector: 'app-modifica-stati-ente-dialog',
  templateUrl: './modifica-stati-ente-dialog.component.html',
  styleUrls: ['./modifica-stati-ente-dialog.component.css']
})
export class ModificaStatiEnteDialogComponent implements OnInit {
  public form: FormGroup;
  public dialogTitle: string;
  public compilazioneEntiDto: ModelEventiCalamitosi.ModStatoCompilazioneEntiDto = {
    entiList: null,
    dataChiusuraDati: null,
    allModStatoCompilazione: null,
    azione: null,
    idEvento: null,
    idTemplate: null,
    enteFilterDTO: {
      idTemplate: null,
      idEnte: null,
      descrizione: "",
      abilitato: "",
      nodeCode: "",
      tipologiaEnte: "",
      provincia: "",
      statoRaccoltaDati: "",
      statoCorrezioneDati: ""
    }
  };

  constructor(
    @Inject(MAT_DIALOG_DATA) data,
    private dialogRef: MatDialogRef<ModificaStatiEnteDialogComponent>,
    private alertsCenterService: AlertsCenterService,
    private datePipe: DatePipe,
    private entiService: EntiService) {
    this.compilazioneEntiDto.entiList = data.entiList,
      this.compilazioneEntiDto.azione = data.azione,
      this.dialogTitle = data.azione,
      this.compilazioneEntiDto.idEvento = data.idEvento,
      this.compilazioneEntiDto.idTemplate = data.idTemplate,
      this.compilazioneEntiDto.enteFilterDTO = data.enteFilter,
      this.compilazioneEntiDto.allModStatoCompilazione = data.allModStatoCompilazione
    this.buildForm();
  }

  ngOnInit(): void {
  }

  buildForm() {
    this.form = new FormGroup({
      dataChiusuraDati: new FormControl({ value: null }, [Validators.required])
    });
  }

  modificaStatoCompilazione() {
    if (!this.form.controls.dataChiusuraDati.errors) {
      this.compilazioneEntiDto.dataChiusuraDati = this.datePipe.transform(this.form.controls.dataChiusuraDati.value, "yyyy-MM-dd");
      if (this.checkData()) {
        this.entiService.modificaStatoCompilazione(this.compilazioneEntiDto).subscribe(result => {
          this.alertsCenterService.showAlert({
            message: 'Modifica stato compilazione enti avvenuta con successo',
            type: 'success',
            autoClosable: false
          });
        },
          err => {
            this.alertsCenterService.showAlert({
              message: err.error.esitoServizio.descrizioneEsito,
              type: 'danger',
              autoClosable: false
            });
          },
          () => {
            //this.dialogRef.close(true);
            this.dialogRef.close(this.compilazioneEntiDto);
          });
      } else {
        this.alertsCenterService.showAlert({
          message: "Inserire una data più grande di quella odierna",
          type: 'danger',
          autoClosable: false
        });
      }
    } else {
      this.markAsTouched()
    }
  }

  markAsTouched() {
    this.form.controls.dataChiusuraDati.markAsTouched();
  }

  checkData() {
    let currentValidDate = new Date()
    currentValidDate.setHours(0,0,0,0);
    if (this.form.controls.dataChiusuraDati.value < currentValidDate) {
      return false;
    } else {
      return true;
    }
  }

}
